<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp; Stock Detail</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mt-3">Stock Detail</h5>
              <!-- <div class="row align-items-center justify-content-between mb-4">
                <div class="col-lg-10">
                </div>
                <div class="col-lg-2 text-right">
                  <button class="btn btn-primary">History</button>
                </div>
              </div> -->
            </div>
            <div class="container">
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  Status
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="status" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  Supplier
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="supplier" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  PR Number
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="poNumber" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  Type
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="type" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  Product
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="product" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  Location
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="location" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  Serial Number
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="sn" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-center my-1">
                <div class="col-lg-2">
                  Stock Code
                </div>
                <div class="col-lg-10 pl-0">
                  <input type="text" v-model="sc" class="form-control" disabled>
                </div>
              </div>
              <div class="row align-items-start my-1" v-if="type !== 'Monitor'">
                <div class="col-lg-2">
                  Component
                </div>
                <div class="col-lg-10 pl-0">
                  <div class="p-2 component-border rounded" v-if="components.length > 0">
                    <div v-for="(item,i) in components" :key="`item${i}`">
                      <div v-for="index in item.itemQty" :key="`${item.itemName}-${i}-${index}`">
                        {{item.itemName}}
                      </div>
                    </div>
                  </div>
                  <div class="p-2 component-border rounded" v-else>
                    -
                  </div>
                </div>
              </div>
              <div class="row" v-if="status === 'Ready Stock'">
                <div class="col-12">
                  <button class="btn btn-primary mt-4 float-right" @click="openModalTrouble()">Trouble</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalTrouble" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="change-title">
                            <!-- <h4 class="modal-title">Trouble</h4> -->
                        </div>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h5>Set to trouble {{product}}</h5>
                        <div class="row mt-3">
                          <div class="col-2 mt-auto">
                            <label>Warehouse</label> 
                          </div>
                          <div class="col-10">
                              <multiselect v-model="warehouse" :options="selectWarehouse" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Warehouse"></multiselect>
                          </div>
                        </div>                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary btn-sm" :disabled="loadingSave" @click="setTrouble()"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingSave"/>Save</button>
                    </div>
                </div>
            </div>
        </div>    
      </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SideBar from '../SideBar.vue';
export default {
  name: 'StockDetailPageNew',
  components: {
    Multiselect,
    SideBar
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
      warehouse:"",
      selectWarehouse:[],
      permission: [],
      admin: '',
      adminId: '',
      uniqueId: '',
      dataDetail: [],
      viewEmployee: false,
      status: '',
      supplier: '',
      poNumber: '',
      type: '',
      product: '',
      location: '',
      sn: '',
      sc: '',
      components: [],
      loadingSave:false
    }
  },
  methods: {
    getTroubleWarehouse(){
      this.$http.get(process.env.GET_WAREHOUSE_BY_STATUS+"/Trouble Stock", {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if(res.data.status == 200) {
            this.selectWarehouse = res.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    setTrouble() {
      if (this.warehouse == "") {
        swal("Sorry", "Warehouse harus dipilih!", "error", {
            button: "Ok",
        });
      }else{
        self = this
        this.loadingSave = true
        const payload = {
          fromWarehouse: this.dataDetail.warehouse,
          toWarehouse: this.warehouse !== null ? this.warehouse.replace(this.spaceRegex, ' ') : this.warehouse,
          itemCode: this.dataDetail.itemCode,
          itemName: this.product,
          itemGroup: this.type,
          qty: 1,
        }

        if (this.sn) {
          payload.sn = this.sn
          payload.bom = this.dataDetail.bomName
          payload.description = this.dataDetail.description
          payload.idSN = this.dataDetail.id
        }
        
        this.$http.post(process.env.SET_STOCK_TO_TROUBLE, payload,{
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
          })
          .then(res => {
            if(res.data.status == 200) {
              swal("Berhasil", "Product has been updated to trouble stock" , "success", {
                  button: "Ok",
              }).then((value) => {
                $("#modalTrouble").modal("hide");
                this.loadingSave = false
                this.getData()
              })
            }else{
              this.loadingSave = false
              swal("Error", res.data.message , "error", {
                  button: "Ok",
              })
            }
          })
          .catch(error => {
            self.loadingSave = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    openModalTrouble(){
      $("#modalTrouble").modal("show");
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toPage(e) {
      this.$router.push(e)
    },
    getData() {
      const sn = this.uniqueId
      this.$http.get(process.env.GET_DATA_DETAIL_ERP + `/${sn}`, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          console.log(res.data.content)
          if(res.data.status == 200) {
            this.dataDetail = res.data.content
            this.status = res.data.content.status
            this.supplier = res.data.content.supplier
            this.poNumber = res.data.content.purchaseReceipt
            this.type = res.data.content.itemGroup
            this.product = res.data.content.itemName
            this.sn = res.data.content.serialNumber
            this.sc = res.data.content.stockCode
            this.components = res.data.content.bom
            this.location = res.data.content.warehouse
            if (this.status === 'Ready Stock') {
              this.getTroubleWarehouse()
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
    },
  },
  created() {
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.uniqueId = this.$route.params.serial
    this.cekLogin()
    this.cekPermission()
    this.getData()
  }
}
</script>

<style scoped>
.component-border {
  border: 1px solid rgb(206, 212, 218);
  background-color: rgb(233, 236, 239);
}
</style>



// WEBPACK FOOTER //
// src/components/Stock/StockDetailNew.vue